'use strict';

/**
 * Full-page loading overlay used while an async action is in flight
 * (e.g. Cart-AddProduct on the PDP).
 *
 * It reuses SFRA's `.veil` element on purpose: stop() defers to
 * `$.spinner().stop()`, which already tears down every `.veil` on the page, so
 * branches that previously stopped the spinner keep working unchanged. Flows
 * that intentionally leave the spinner running (e.g. a redirect) keep the
 * overlay up until the page navigates away.
 *
 * start() can optionally disable one or more elements (typically the add to
 * cart button) for the duration of the overlay; stop() re-enables them. The
 * locked elements are tracked with a marker class rather than a shared
 * variable, so overlapping flows cannot leave a button stuck disabled.
 */

const LOADER_CLASS = 'js-page-loader';
const LOCKED_CLASS = 'js-loader-locked';
const SELECTORS = {
    loaderVeil: `.veil.${LOADER_CLASS}`,
    locked: `.${LOCKED_CLASS}`
};

/**
 * Show the loading overlay.
 * @param {jQuery} [$target] - Element to cover. Defaults to the page (body).
 * @param {jQuery} [$lockElements] - Element(s) to disable while the overlay is shown (e.g. the add to cart button).
 * @returns {void}
 */
const start = ($target, $lockElements) => {
    const $container = ($target && $target.length) ? $target : $('body');

    // Avoid stacking multiple overlays for the same target.
    if (!$container.children(SELECTORS.loaderVeil).length) {
        $container.append(
            `<div class="veil ${LOADER_CLASS}">`
            + '<div class="underlay"></div>'
            + '<span class="loader" role="status" aria-label="Loading"></span>'
            + '</div>'
        );
    }

    if ($lockElements && $lockElements.length) {
        $lockElements.attr('disabled', true).addClass(LOCKED_CLASS);
    }
};

/**
 * Hide the loading overlay and re-enable any elements locked by start().
 * @returns {void}
 */
const stop = () => {
    // Tears down the overlay (and any other page veil, matching the SFRA
    // $.spinner().stop() behaviour this stands in for).
    $.spinner().stop();
    $(SELECTORS.locked).attr('disabled', false).removeClass(LOCKED_CLASS);
};

module.exports = {
    start,
    stop
};
